import React from 'react'

interface ApplicantBlockIconProps {
  color?: string
  width?: number
  height?: number
  alt?: string
}

const ApplicantBlockIcon: React.FC<ApplicantBlockIconProps> = ({
  color = '#000',
  width = 48,
  height = 48,
  alt = 'Form step badge icon',
}) => {
  const maskId = `ApplicantBlockMask-${React.useId()}`
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 48 48'
      aria-label={alt}
    >
      <title>{alt}</title>
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='48'
        height='48'
      >
        <rect width='48' height='48' fill={color} />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d='M38 6C39.1 6 40.0419 6.39147 40.8252 7.1748C41.6085 7.95814 42 8.9 42 10V29.668C40.9166 29.2383 39.7363 29 38.5 29C33.2533 29 29 33.2533 29 38.5C29 39.7363 29.2383 40.9166 29.668 42H10C8.9 42 7.95814 41.6085 7.1748 40.8252C6.39147 40.0419 6 39.1 6 38V10C6 8.9 6.39147 7.95814 7.1748 7.1748C7.95814 6.39147 8.9 6 10 6H38ZM16 30C15.4333 30 14.9585 30.1919 14.5752 30.5752C14.1919 30.9585 14 31.4333 14 32C14 32.5667 14.1919 33.0415 14.5752 33.4248C14.9585 33.8081 15.4333 34 16 34H26C26.5667 34 27.0415 33.8081 27.4248 33.4248C27.8081 33.0415 28 32.5667 28 32C28 31.4333 27.8081 30.9585 27.4248 30.5752C27.0415 30.1919 26.5667 30 26 30H16ZM16 22C15.4333 22 14.9585 22.1919 14.5752 22.5752C14.1919 22.9585 14 23.4333 14 24C14 24.5667 14.1919 25.0415 14.5752 25.4248C14.9585 25.8081 15.4333 26 16 26H32C32.5667 26 33.0415 25.8081 33.4248 25.4248C33.8081 25.0415 34 24.5667 34 24C34 23.4333 33.8081 22.9585 33.4248 22.5752C33.0415 22.1919 32.5667 22 32 22H16ZM16 14C15.4333 14 14.9585 14.1919 14.5752 14.5752C14.1919 14.9585 14 15.4333 14 16C14 16.5667 14.1919 17.0415 14.5752 17.4248C14.9585 17.8081 15.4333 18 16 18H32C32.5667 18 33.0415 17.8081 33.4248 17.4248C33.8081 17.0415 34 16.5667 34 16C34 15.4333 33.8081 14.9585 33.4248 14.5752C33.0415 14.1919 32.5667 14 32 14H16Z'
          fill={color}
        />
        <path
          d='M38.5 46C37.4625 46 36.4875 45.8031 35.575 45.4094C34.6625 45.0156 33.8687 44.4813 33.1937 43.8063C32.5187 43.1313 31.9844 42.3375 31.5906 41.425C31.1969 40.5125 31 39.5375 31 38.5C31 37.4625 31.1969 36.4875 31.5906 35.575C31.9844 34.6625 32.5187 33.8687 33.1937 33.1937C33.8687 32.5187 34.6625 31.9844 35.575 31.5906C36.4875 31.1969 37.4625 31 38.5 31C39.5375 31 40.5125 31.1969 41.425 31.5906C42.3375 31.9844 43.1313 32.5187 43.8063 33.1937C44.4813 33.8687 45.0156 34.6625 45.4094 35.575C45.8031 36.4875 46 37.4625 46 38.5C46 39.5375 45.8031 40.5125 45.4094 41.425C45.0156 42.3375 44.4813 43.1313 43.8063 43.8063C43.1313 44.4813 42.3375 45.0156 41.425 45.4094C40.5125 45.8031 39.5375 46 38.5 46ZM38.5 44.5C40.175 44.5 41.5938 43.9188 42.7563 42.7563C43.9188 41.5938 44.5 40.175 44.5 38.5C44.5 38.4125 44.4969 38.3219 44.4906 38.2281C44.4844 38.1344 44.4813 38.0562 44.4813 37.9937C44.4188 38.3562 44.25 38.6562 43.975 38.8938C43.7 39.1313 43.375 39.25 43 39.25H41.5C41.0875 39.25 40.7344 39.1031 40.4406 38.8094C40.1469 38.5156 40 38.1625 40 37.75V37H37V35.5C37 35.0875 37.1469 34.7344 37.4406 34.4406C37.7344 34.1469 38.0875 34 38.5 34H39.25C39.25 33.7125 39.3281 33.4594 39.4844 33.2406C39.6406 33.0219 39.8312 32.8438 40.0562 32.7063C39.8062 32.6438 39.5531 32.5938 39.2969 32.5563C39.0406 32.5188 38.775 32.5 38.5 32.5C36.825 32.5 35.4062 33.0813 34.2438 34.2438C33.0813 35.4062 32.5 36.825 32.5 38.5H36.25C37.075 38.5 37.7812 38.7938 38.3687 39.3813C38.9562 39.9688 39.25 40.675 39.25 41.5V42.25H37V44.3125C37.25 44.375 37.4969 44.4219 37.7406 44.4531C37.9844 44.4844 38.2375 44.5 38.5 44.5Z'
          fill={color}
        />
      </g>
    </svg>
  )
}

export default ApplicantBlockIcon
